import { supabase } from '@/integrations/supabase/client';

export type ActivityType = 
  | 'login'
  | 'logout'
  | 'create_client'
  | 'update_client'
  | 'delete_client'
  | 'check_in'
  | 'check_out'
  | 'client_status_change'
  | 'create_alert'
  | 'acknowledge_alert'
  | 'acknowledge_reminder'
  | 'add_service'
  | 'delete_service'
  | 'create_note'
  | 'create_roster'
  | 'update_roster'
  | 'update_user'
  | 'create_user'
  | 'reset_password'
  | 'manage_access'
  | 'upload_document'
  | 'delete_document'
  | 'create_inspection'
  | 'submit_inspection'
  | 'duplicate_override'
  | 'assign_case_manager'
  | 'room_assignment'
  | 'assign_pass'
  | 'update_pass'
  | 'clear_pass'
  | 'archive_client'
  | 'bed_count'
  | 'bed_count_start'
  | 'bed_count_entry_marked'
  | 'bed_count_signoff'
  | 'bed_count_avc_call'
  | 'bed_count_waitlist_add'
  | 'bed_count_waitlist_resolve'
  | 'property_return'
  | 'unbed_client'
  | 'exit_client'
  | 're_intake_client'
  | 'release_reservation'
  | 'case_manager_cleared'
  | 'family_checkin'
  | 'service_logged'
  | 'service_removed'
  | 'document_uploaded'
  | 'photo_updated'
  | 'merge_clients';

interface LogActivityParams {
  actionType: ActivityType;
  actionDetails?: Record<string, any>;
  siteId?: string;
}

export const logActivity = async ({ actionType, actionDetails, siteId }: LogActivityParams) => {
  try {
    const { data: { user } } = await supabase.auth.getUser();
    
    if (!user) return;

    await supabase.from('user_activity_logs').insert({
      user_id: user.id,
      action_type: actionType,
      action_details: actionDetails || null,
      site_id: siteId || null,
      user_agent: navigator.userAgent
    });
  } catch (error) {
    console.error('Error logging activity:', error);
  }
};

export const useActivityLog = () => {
  return { logActivity };
};
